function matchingSelector(element, selector) {
  if (!element || element.nodeType !== 1 || !element.parentElement) {
    return false;
  }

  return element.matches(selector);
}

export { matchingSelector };